import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AdminTable from 'common/AdminTable';
// import TruncatedMessage from 'common/TruncatedMessage';
import { updateOrderListDB, getOrderListWithdrawelDB } from 'slice/orderSliceDB';
// import { useNavigate } from 'react-router-dom';

const Withdrawel = () => {
    const dispatch = useDispatch();
    // const navigate = useNavigate()
    const cartData = useSelector((state) => state.orderDB);
    const [showModal, setShowModal] = useState(false);
    const [currentProduct, setCurrentProduct] = useState(null);
    // const [imageFile, setImageFile] = useState(null);

    useEffect(() => {
        dispatch(getOrderListWithdrawelDB());
    }, [dispatch]);

    // When Edit button is clicked, open the modal with current product details
    const handleEditClick = (product) => {
        setCurrentProduct(product);
        setShowModal(true);
    };

    // Close the modal and reset state
    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentProduct(null);
    };

    // Handle saving the edited product
    const handleSave = () => {
        const formData = new FormData();
        formData.append('id', currentProduct.id);
        formData.append('status', "acceptedWithdrawel");
        dispatch(updateOrderListDB({ id: currentProduct.id, data: currentProduct }));
        handleCloseModal(); 
    };

    // Table Headers
    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Price',
            accessor: 'total_amount',
        },
        {
            Header: 'Name',
            accessor: 'customer.name',
            Cell : ({row}) => {
                return <>{row?.original?.customer?.name ? row.original.customer.name.toUpperCase() : ''}</>
            }
        },
        {
            Header: 'User',
            accessor: 'phone',
        },
        {
            Header: 'Type',
            accessor: 'payment_method',
        },
        {
            Header: 'Pay to',
            accessor: 'shipping_address',
        },
        {
            Header: 'Date',
            accessor: 'createdAt',
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: ({ row }) => {
                const status = row.original.status || ''; // Add a fallback to an empty string
                let bgColor;
        
                switch (status) {
                    case 'pending':
                        bgColor = 'bg-warning'; // Yellow
                        break;
                    case 'accept':
                        bgColor = 'bg-success'; // Green
                        break;
                    case 'reject':
                        bgColor = 'bg-danger'; // Red
                        break;
                    default:
                        bgColor = '';
                }
        
                return (
                    <span className={`badge ${bgColor} text-white p-2`}>
                        {status ? status.charAt(0).toUpperCase() + status.slice(1) : 'N/A'}
                    </span>
                );
            }
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <>
                    <button
                        className="btn editbtn mx-1"
                        onClick={() => handleEditClick(row.original)} // Correct function
                    >
                        Confirm
                    </button>
                    {/* <button
                        className="btn editbtn mx-1"
                        onClick={() => navigate(`/billing/details/${row.original.id}`)} // Correct function
                    >
                        See
                    </button> */}
                </>
            ),
        },
    ];

    return (
        <>
            <div className="container-fluid mt-5">
                <div className="mainheadig mx-4">
                    <h4 className="text-white font-weight-bold">Order List</h4>
                </div>

                {cartData?.data?.length > 0 && (
                    <AdminTable tableHeaders={tableHeaders} tableData={cartData.data} />
                )}
            </div>

            {/* Edit Modal */}
            {showModal && currentProduct && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="editModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="editModalLabel">View Order</h5>
                                <button type="button" className="close" onClick={handleCloseModal} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="form-group">
                                        <label htmlFor="status">Action</label>
                                        <select className='form-control' onChange={(e) => setCurrentProduct({ ...currentProduct, status: e.target.value })}>
                                            <option>pending</option>
                                            <option>accept</option>
                                            <option>reject</option>
                                        </select>
                                    </div>
  
                                    {/* <div className="form-group">
                                        <label htmlFor="productPrice">Price</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="productPrice"
                                            value={currentProduct?.total_amount}
                                            onChange={(e) => setCurrentProduct({ ...currentProduct, total_amount: e.target.value })}
                                        />
                                    </div> */}
{/*   
                                    <div className="form-group">
                                        <label htmlFor="productDescription">Receipt</label>
                                        <img src={`${process.env.REACT_APP_BACKEND}payment_slip/${currentProduct.slip}`} className='img-fluid9' alt='' height={200}/>
                                    </div> */}

                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Close</button>
                                <button type="button" className="btn btn-primary" onClick={handleSave}>Save changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Withdrawel;
